<div class="card" style="position: relative">
    <p-toast></p-toast>
    <span class="page-title"><i class="pi pi-cog page-title-icon"></i>POS Config</span>
    <div class="mt-6">
        <p-tabView class="pt-8">

            <p-tabPanel header="POS Allocation">
                <div class="info-banner">
                    <i class="pi pi-info-circle info-banner-icon"></i>
                    <small>Link a POS device to an agent by assigning their user account, bank, and POS code. This mapping allows the system to automatically attribute POS transactions to the correct agent during reconciliation.</small>
                </div>
                <div class="controls-wrapper">
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">User</label>
                        <p-dropdown [options]="users()" [(ngModel)]="allocationUser" placeholder="Select User"
                            optionLabel="username" optionValue="id" [filter]="true" [loading]="users().length==0"
                            filterBy="username"></p-dropdown>
                    </div>
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Bank</label>
                        <p-dropdown [options]="banks()" [(ngModel)]="allocationBank" placeholder="Select Bank"
                            optionLabel="label" optionValue="value"></p-dropdown>
                    </div>
                    <span class="p-input-icon-left">
                        <label class="ctrl-label">POS Code</label>
                        <i class="pi pi-tag mt-2"></i>
                        <input pInputText [(ngModel)]="posCode" placeholder="POS Code" class="text-input" />
                    </span>
                </div>
                <div class="page-actions-wrapper">
                    <p-button label="Save Allocation" icon="pi pi-check" (onClick)="submitAllocation()"
                        [disabled]="!allocationUser || !allocationBank || !posCode || savingAllocation()"
                        [loading]="savingAllocation()" [text]="true" [raised]="true" severity="success">
                    </p-button>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Configuration">
                <div class="info-banner">
                    <i class="pi pi-info-circle info-banner-icon"></i>
                    <small>Configure how POS codes are extracted from bank statement descriptions. Define a regex pattern for a specific bank and the column the POS code appears in</small>
                </div>
                <div class="controls-wrapper">
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Bank</label>
                        <p-dropdown [options]="banks()" [(ngModel)]="configBank" placeholder="Select Bank"
                            optionLabel="label" optionValue="value"></p-dropdown>
                    </div>
                    <span class="p-input-icon-left">
                        <label class="ctrl-label">Regex Pattern</label>
                        <i class="pi pi-code mt-2"></i>
                        <input pInputText [(ngModel)]="regexPattern" placeholder="e.g. ^POS\d+" class="text-input" />
                    </span>
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Column Name</label>
                        <p-dropdown [options]="columnNameOptions" [(ngModel)]="configColumnName"
                            placeholder="Select Column Name" optionLabel="label" optionValue="value"></p-dropdown>
                    </div>
                </div>
                <div class="page-actions-wrapper">
                    <p-button label="Save Config" icon="pi pi-check" (onClick)="submitConfig()"
                        [disabled]="!configBank || !regexPattern || !configColumnName || savingConfig()"
                        [loading]="savingConfig()" [text]="true" [raised]="true" severity="success">
                    </p-button>
                </div>
            </p-tabPanel>

        </p-tabView>
    </div>
</div>